module.exports = __webpack_public_path__ + "img/04.264170db.jpg";